export default "__VITE_ASSET__$PK2ThuC__"